import ExpireUnlockLinkModalComponent from "./ExpireUnlockLinkModalComponent";

export default ExpireUnlockLinkModalComponent;